// extracted by mini-css-extract-plugin
export var parcelRow = "_s7-0";